import React, { useState } from "react";

import {
    View,
    Text,
    SafeAreaView,
    Image,
    TouchableOpacity,
    Platform,
    ScrollView,
    Dimensions,
    Button,
  } from "react-native";
import { Entypo } from "@expo/vector-icons";
import WideButton from "../../commonComponents/wideButton";
import getPlatformType from "../../helpers/getPlatform";
import { useNavigation } from "@react-navigation/native";
import { AntDesign } from "@expo/vector-icons";
import CustomPopUp from "./../../commonComponents/customPopUp/customPopUp";

import {
    Container,
    InnerContainer,
    Heading,
    AddDocBtnBox,
    HeadingText,
    ListBox,
    DocumentBox,
    DocName,
    DocNameText,
    DocShare,
    DocShareText,
    DocRemove,
    DocRemoveText,
    DocDate,
    BackBtnBox,
    DocBoxLeft,
    DocBoxRight,
    DocDateText,
    ButtonFooter,
    MainContent,
  } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { validateAssetsUrl } from "../../helpers/regex";
const layoutType = getPlatformType();
import {
    fetchDoc,
    updateSharedStatusOfDoc,
    deleteDoc,
  } from "../../redux/actions/auth";

import { COLORS } from "../../constants/colorPallete";
import { openUrlHelpers } from "../../helpers/openDocHelpers";
const MyDocs =(props)=>{
    var navigation =useNavigation();
    var documents=useSelector(state=>state.authReducer?.docs);
    var dispatch=useDispatch();
    const [docToRemove,setRemoveDoc]=useState('');
    const [popUpIsVisible,setShowPopup]=useState(false);
   
    const  modifyDate = (date) => {
        return date.substr(0, 10).split("-").join("/");
      };

   const deleteDocument = (data) => {
        dispatch(deleteDoc(data?.document_id))
        setRemoveDoc(null);
      };
   const openDoc = (doc) => {
     openUrlHelpers(doc.filepath)
        // if (Platform.OS === "web") {
        //   if (validateAssetsUrl(doc.filepath)) {
        //       openDoc
        //   } else {
        //     window.open("http://assets.openbrix.co.uk/" + `${doc.filepath}`);
        //   }
        // }
      };
   const updateShareStatus = (data) => {

    dispatch(updateSharedStatusOfDoc(data?.document_id, !data?.isShared))
     };    

    return(
      <View style={{flex:1,alignSelf:'flex-start',padding:20}}>
          <Text style={{fontSize:16,fontWeight:'bold'}}>Uploaded Documents</Text>
          <Text style={{fontSize:14,marginVertical:10}}>{`Upload all your important documents such as identification, right to rent documents and other related information that can be securely and safely shared between you and your agent.`}</Text>
        
                <ListBox>
                  {documents?.data?.myDocuments.length ? (
                    <React.Fragment>
                      {documents?.data?.myDocuments.map((doc) => (
                        <DocumentBox>
                          <DocBoxLeft>
                            <DocName>
                              <DocNameText
                              id={"MYDOCS-FILE-NAME"}
                              onPress={() => openDoc(doc)}>
                                {doc.filename}
                              </DocNameText>
                            </DocName>
                            <DocShare
                              onPress={() => updateShareStatus(doc)}
                              id={"MYDOCS-FILE-NAME"}
                            >
                              <AntDesign
                                name="eye"
                                size={22}
                                color={doc.isShared ? COLORS.orange : "#bdbdbd"}
                              />
                              <DocShareText
                                style={{
                                  color: doc.isShared ? "#000" : "#bdbdbd",
                                }}
                              >
                                {" "}
                               {doc.isShared? "Shared":"Share"}
                              </DocShareText>
                            </DocShare>
                          </DocBoxLeft>
                          <DocBoxRight>
                            <DocRemove
                             id={"MYDOCS-REMOVE-DOCS"}
                              onPress={() => {
                                setRemoveDoc(doc);
                                setShowPopup(true)
                              }}
                            >
                              <Entypo name="cross" size={22} color={COLORS.orange} />
                              <DocRemoveText>Remove</DocRemoveText>
                            </DocRemove>
                            <DocDate 
                               id={"MYDOCS-DATE"}
                            onPress={() => openDoc(doc)}>
                              <DocDateText>
                                {modifyDate(doc.createdAt)}
                              </DocDateText>
                              <Entypo
                                name="chevron-right"
                                size={22}
                                color={COLORS.orange}
                              />
                            </DocDate>
                          </DocBoxRight>
                        </DocumentBox>
                      ))}
                    </React.Fragment>
                  ) : null}
                </ListBox>
                <AddDocBtnBox>
                      <WideButton
                      id={"ADD-DOCS"}
                        width="100%"
                        gradiant
                        borderRadius={15}
                        childText="Add Document"
                        onPress={() =>
                        navigation.navigate("Add Documents")
                        }
                      />
                    </AddDocBtnBox>
                <CustomPopUp
          loading={popUpIsVisible}
          primaryButtonText={"Sure"}
          secondaryButtonText={"cancel"}
          primaryText={"Remove Doc?"}
          secondaryText={" Are you sure you want to remove Doc?"}
          onPrimaryButtonPress={() => {
              setShowPopup(false)
              deleteDocument(docToRemove);
          }}
          onSecondaryButtonPress={() => {
            setShowPopup(false)
          }}
        />

      </View>  
    )
}
export default MyDocs;